import { Button } from "@admin/components/atoms/Button";
import { Modal, ModalProps } from "@admin/components/atoms/Modal";
import { activateUser } from "@enos-monorepo/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

interface ActivatePersonnelModalProps extends ModalProps {
  userId: string;
  companyId: string;
  personnelName: string;
}

export default function ActivatePersonnelModal({
  userId,
  companyId,
  personnelName,
  ...props
}: ActivatePersonnelModalProps) {
  const { t } = useTranslation();
  const querryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: activateUser,
    onSuccess: () => {
      props.onClose?.();
      toast.success(
        t("personnel.The personnel has been activated successfully"),
      );
      querryClient.invalidateQueries({
        queryKey: ["allLocationUsers", companyId],
      });
    },
    onError: () => {
      toast.error(t("personnel.Unable to activate personnel"));
    },
  });

  const handleDeactivatePersonnel = useCallback(() => {
    mutation.mutate(userId);
  }, [mutation, userId]);

  return (
    <Modal
      title={t("personnel.Activate Personnel", { personnelName })}
      {...props}
      actionButtons={
        <>
          <Button
            variant="secondary"
            onClick={props.onClose}
            disabled={mutation.isPending}
          >
            {t("common.Discard")}
          </Button>
          <Button
            onClick={handleDeactivatePersonnel}
            loading={mutation.isPending}
          >
            {t("personnel.Activate Personnel Text")}
          </Button>
        </>
      }
    >
      <h2>
        {t("personnel.Personnel Activation Confirmation", {
          personnelName: personnelName,
        })}
      </h2>
    </Modal>
  );
}
